import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("studykit_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  const status = e?.response?.status;
  if (status >= 500)
    return `Le serveur redémarre (erreur ${status}). Patiente 30 secondes puis réessaie.`;
  if (status === 429) return "Trop de tentatives. Patiente quelques minutes.";
  if (!e?.response)
    return "Impossible de joindre le serveur. Vérifie ta connexion internet puis réessaie.";
  return "Une erreur est survenue. Réessaie.";
}

export async function withRetry(fn, retries = 2, delay = 2500) {
  try {
    return await fn();
  } catch (e) {
    const status = e?.response?.status;
    const retryable = !e?.response || status >= 500;
    if (retries > 0 && retryable) {
      await new Promise((r) => setTimeout(r, delay));
      return withRetry(fn, retries - 1, delay * 2);
    }
    throw e;
  }
}

export async function downloadPdf(path, filename) {
  const res = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export default api;
